import { useContext } from 'react'
import Post2 from 'components/ui/Post2'
import PostSkeleton from 'components/skeletons/PostSkeleton'
import PostSkeletonDark from 'components/skeletons/PostSkeletonDark'
import { AppState } from 'App';

const Feed = ({ posts, icons }) => {

    const [appState, setAppState] = useContext(AppState)

    return (
        <div className="space-y-4 2xl:space-y-8">

            {appState.loadingContext ? (
                <>
                <div className="block space-y-8 yl:space-y-4 2xl:space-y-8 dark:hidden">
                    <PostSkeleton/>
                    <PostSkeleton/>
                </div>

                <div className="hidden space-y-8 yl:space-y-4 2xl:space-y-8 dark:block">
                    <PostSkeletonDark/>
                    <PostSkeletonDark/>
                </div>
                </>

            ) : null}


            { posts && posts.map(post => (
                <Post2
                    key={post.id}
                    id={post.id}
                    post={post.post}
                    photos={post.photos}
                    tag={post.tag}
                    date={post.date}
                    city={post.city}
                    town={post.town}
                    temperature={post.temperature}
                    weather={post.weather}
                    icon={post.weatherIcon}
                    liked={post.liked}
                    hidden={post.hidden}
                    icons={icons}
                    order={post.order}
                />
            ))}
        </div>
    )
}

export default Feed
